<div class="step-confirmation">
  <div class="confirmation-content">
    <h2 class="confirmation-heading" data-testid="confirmation-heading">
      Thank you
    </h2>

    <div class="confirmation-message" data-testid="confirmation-message">
      <p>
        The Request has been received by UKG Inc Print Services. Please note the
        Request Number:
        <strong data-testid="confirmation-request-number">{{
          requestNumber
        }}</strong>
        for future reference. An email confirmation should be received shortly.
        For your convenience, the status of the request can be viewed at any
        time on the Requests page.
      </p>
    </div>

    <div class="confirmation-actions">
      <ukg-button
        emphasis="high"
        size="medium"
        type="button"
        (click)="navigateToRequest()"
        (keydown.enter)="navigateToRequest()"
        (keydown.space)="navigateToRequest(); $event.preventDefault()"
        data-testid="confirmation-view-request-link">
        View Request
      </ukg-button>
    </div>
  </div>
</div>
